import { Component } from '@angular/core';
import { DocumentSearchResult } from '../document/models/documentSearchResult';
import { MyChangeRequestsService } from './services/my-change-requests.service';
import { MyChangeRequestsConstants } from './constants/my-change-requests-constants';
import { DocumentLibraryConstants } from '../document/document-library-constants';
import { LabelConstants } from '../shared/constants/label-constants';
import { DefaultFilter } from '../shared/models/panel-list/default-filter';
import { ActivatedRoute } from '@angular/router';
import { PanelListConstants } from '../shared/constants/panel-list-constants';

@Component({
  selector: 'app-my-change-requests',
  templateUrl: './my-change-requests.component.html',
  styleUrls: ['./my-change-requests.component.scss']
})
export class MyChangeRequestsComponent {
  documentSearchResult: DocumentSearchResult[] = [];
  topBarTitle:string = MyChangeRequestsConstants.MyChangeRequestsTitle;
  PanelListType:string = DocumentLibraryConstants.ChangeRequest_PanelListType;
  showLoader : boolean = true;
  isScreenAccessible : boolean = true;
  errorMessage !: string;
  defaultFiltersSelected: DefaultFilter[] = [];
  defaultcrtype: any;

  constructor(private myChangeRequestsService: MyChangeRequestsService, private router: ActivatedRoute){
    this.router.queryParams.subscribe((queryParams:any) => {
      this.defaultcrtype = queryParams.changeRequestItemType;
     }
    );
   }

  ngOnInit(): void{
    this.getPanelListData();
    if ( this.defaultcrtype === PanelListConstants.ChangeRequestItemType_Manual 
      || this.defaultcrtype === PanelListConstants.ChangeRequestItemType_PeriodicReview) {
      this.setDefaultPanelListFilters([{filterFieldName : PanelListConstants.ChangeRequestItemType_FilterName,
        filterValues : [this.defaultcrtype]}]);      
    }
  }

  setDefaultPanelListFilters(defaultFilters: DefaultFilter[]) {
    this.defaultFiltersSelected = defaultFilters;
  }

  getPanelListData(){
      this.myChangeRequestsService.getMyChangeRequests().subscribe({
          error: (err) => {
              if (err.status === LabelConstants.Forbidden_StatusCode) {
                  this.errorMessage = err.error.detail;
              }
              this.isScreenAccessible = false
          },
          next: (serviceData) => {
              this.documentSearchResult = serviceData;
              this.showLoader = false;
          }
    });
  }

}
